// O portal redireciona para a plataforma com dois pares de tokens na URL:
// `token`/`refresh_token`, emitidos pela Sensedia, e `token_apigee`/`refresh_token_apigee`,
// emitidos pelo Apigee. Cada gateway só valida o token que ele mesmo emitiu, e todos os
// base paths da aplicação apontam para o Apigee, então é o par `_apigee` que vale aqui.
const urlParams = new URLSearchParams(window.location.search);

export const tokenPortalFromUrl = urlParams.get('token_apigee');

export const refreshTokenPortalFromUrl = urlParams.get('refresh_token_apigee');

// O access token do Apigee vive ~300s (a Sensedia emitia com 3600s) e o portal não manda
// o `expires_in` na URL. O valor alimenta o shouldGenerateNewToken, que renova o token
// depois de decorrida uma fração dessa validade.
export const APIGEE_TOKEN_TTL_SECONDS = '300';

if (tokenPortalFromUrl) {
  localStorage.setItem('tokenPortal', tokenPortalFromUrl);
  localStorage.setItem('expiresIn', APIGEE_TOKEN_TTL_SECONDS);
  localStorage.setItem('tokenCreatedAt', String(Date.now()));
}

if (refreshTokenPortalFromUrl) {
  localStorage.setItem('refreshToken', refreshTokenPortalFromUrl);
}

// O localStorage é a fonte da verdade, não o parâmetro da URL: o token da URL já foi
// gravado ali acima e o refresh-token substitui esse valor durante a sessão. Com o TTL
// curto do Apigee, continuar preferindo o parâmetro da URL deixaria a aplicação usando
// um token vencido logo depois do primeiro refresh.
export const getAccessToken = () =>
  localStorage.getItem('tokenPortal') ?? tokenPortalFromUrl;
